var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var vein = require('veinjs');

function StoreLocator(el) {
  this.$el = $(el);

  var $form = this.$el.find('form');
  var $addressWrap = this.$el.find('div.address-input');
  var $locationBtnContainer = this.$el.find('div.geo_button_cont');
  var $searchBtn = $('.wpslsubmit');

  this.currentPage = 0;

  var submitted = false;

  this.$el.one('click', '.wpslsubmit', function() {
    submitted = true;
  });

  this.$el.on('click', 'li', function(event) {
    var $li = $(event.currentTarget);

    this.activateResult($li.attr('data-result'));
  }.bind(this));

  $(window).on('vsc-page-resized vsc-page-changed', this.update.bind(this));

  $(window).on('vsc-location-no-results', this.noResults.bind(this));

  $(window).on('vsc-map-rendered', function() {
    var bounds = new google.maps.LatLngBounds();

    for(var i = 0; i < markers.length; i++) {
      if(markers[i].getVisible()) {
        bounds.extend(markers[i].getPosition());
      }
    }

    googlemap.fitBounds(bounds);

    this.paginate(0);

    if(submitted) {
      $('html,body').animate({
        scrollTop: $('.store-locator-content').offset().top - 69
      }, 450);
    }
  }.bind(this));

  this.$el.on('click', '[data-locator-page]', function(event) {
    var dir = $(event.currentTarget).attr('data-locator-page');
    var page = dir == 'prev' ? this.currentPage - 1 : this.currentPage + 1;
    this.paginate(page);
  }.bind(this));
}

StoreLocator.prototype = {
  noResults: function() {
    $('.store-locator').removeClass('open');
    $('.store-locator-content').css('height', '0');
  },
  paginate: function(page) {
    page = page || 0;

    this.currentPage = page;

    var $results = this.$el.find('li');
    var pageCount = 4;

    $('.store-locator').toggleClass('open', $results.length > 0);
    $('.store-locator-content').css( "height", '' );

    var start = pageCount * page;
    var end = pageCount * (page+1);

    var $showResults = $results.slice(start, end);

    $results.not($showResults).hide();
    $showResults.show();

    if(start > 0) {
      $('[data-locator-page="prev"]').removeAttr('disabled');
    } else {
      $('[data-locator-page="prev"]').attr('disabled', true);
    }

    if($results.length > end) {
      $('[data-locator-page="next"]').removeAttr('disabled');
    } else {
      $('[data-locator-page="next"]').attr('disabled', true);
    }
  },

  update: function() {
    this.initMarkers();
    this.moveHeading();
    this.paginate(this.currentPage);

    vein.inject('.store-locator-content', {
      'height': $('.store-locator-results-container').outerHeight()+'px'
    });

    setTimeout(function() {
      google.maps.event.trigger(googlemap, 'resize');
    }, 10);
  },

  moveHeading: function() {
    var $header = $('.store-locator-results-header');
    var $h = $('.store-locator-results .wpsl-results-header');

    if($h.length) {
      $header.find('h3').replaceWith($h);
      // $h.prependTo($header);
    }
  },

  initMarkers: function() {
    var activateResult = this.activateResult.bind(this);

    for(var i = 0; i < markers.length; i++) {
      google.maps.event.clearListeners(markers[i], 'click');

      google.maps.event.addListener(markers[i], 'click', (function(i) {
        return function() {
          activateResult(i);
        }
      })(i));
    }
  },

  activateResult: function(index) {
    var $li = $('[data-result="'+index+'"]');

    if(!$li.is(':visible')) {
      var page = Math.floor(index / 4);
      this.paginate(page);
    }

    $('[data-result="'+index+'"]').addClass('active').siblings().removeClass('active');
    googlemap.panTo(markers[index].getPosition());

    for(var i = 0; i < markers.length; i++) {
      if(i == index) {
        markers[i].setIcon({
          url: SiteVars['template_url']+'/assets/images/map-marker-active.png',
          scaledSize: new google.maps.Size(37,56),
          anchor: new google.maps.Point(18.5,56)
        })
      } else {
        markers[i].setIcon(wpsl_locator.mappin);
      }
    }
  }
}

module.exports = StoreLocator;
